import React from "react";
import "./Feature.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLeaf,
  faChartArea,
  faTint,
  faWater,
  faSatelliteDish,
  faCloud,
  faMountain,
  faCloudRain,
} from "@fortawesome/free-solid-svg-icons";

// Service data array
const services = [
  {
    icon: faLeaf,
    title: "Crop Health Monitoring",
    description:
      "Track crop health with satellite data, detecting diseases, pest attacks, and nutrient deficiencies early for better yields.",
  },
  {
    icon: faChartArea,
    title: "Geo Location",
    description:
      "Get precise location-based farming recommendations tailored to your farmland’s unique conditions.",
  },
  {
    icon: faCloud,
    title: "Weather Forecast",
    description:
      "Accurate weather predictions help farmers protect crops and plan activities efficiently.",
  },
  {
    icon: faCloudRain,
    title: "Hyperlocal Weather",
    description:
      "Receive detailed weather updates specific to your exact location for precise farming decisions.",
  },
  {
    icon: faTint,
    title: "Evapotranspiration",
    description:
      "Measure water loss from soil and crops to optimize irrigation and prevent drought stress.",
  },
  {
    icon: faWater,
    title: "Water Stress",
    description:
      "Identify dry areas in your farm and take corrective actions to enhance crop health.",
  },
  {
    icon: faSatelliteDish,
    title: "Radar Data",
    description:
      "Access radar-based weather insights to prepare for storms, rainfall, or dry spells.",
  },
  {
    icon: faMountain,
    title: "Digital Elevation Model",
    description:
      "3D models for soil conservation, water management, and land planning, optimizing efficiency.",
  },
];

const Feature = () => {
  return (
    <section className="feature-section">
      <div className="feature-container">
        <h2 className="feature-title">
          Our <span>Satellite Services</span>
        </h2>
        <h3 className="feature-subtitle">
          Farmology uses satellite technology to provide real-time insights and
          help farmers make informed decisions.
        </h3>
        <div className="feature-grid">
          {services.map((service, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <FontAwesomeIcon icon={service.icon} className="icon" />
              </div>
              <h3 className="feature-card-title">{service.title}</h3>
              <p className="feature-card-desc">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Feature;
